const SvgPort = (props) => (
  <svg height="1em" viewBox="0 0 16 15" width="1em" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M-1-2h18v18H-1z" />
      <path
        d="M4.309 14.5h7.382l1-2H15a.5.5 0 0 0 .5-.5V1a.5.5 0 0 0-.5-.5H1a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h2.309l1 2z"
        stroke="currentColor"
      />
      <path
        d="M5 6a.5.5 0 0 1-.5-.5V1h1v4.5A.5.5 0 0 1 5 6zM8 6a.5.5 0 0 1-.5-.5V1h1v4.5A.5.5 0 0 1 8 6zM11 6a.5.5 0 0 1-.5-.5V1h1v4.5a.5.5 0 0 1-.5.5z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default SvgPort
